module.exports = __webpack_public_path__ + "static/img/erweima.6ec5d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/erweima.png
// module id = DxoH
// module chunks = 1